import { LitElement, property, html, css } from '/web_modules/lit-element.js';
import { connect } from '/web_modules/pwa-helpers/connect-mixin.js';
import { store, RootState } from '../store.js';
import { FchSharedStyles } from '../styles/fch-shared-styles.js';
import { updateLocation, addSessionToRedux } from '../actions/app.js';
import { installRouter } from '/web_modules/pwa-helpers/router.js';
import { classMap } from '/web_modules/lit-html/directives/class-map.js';
import { Snackbar, loggedInMemberSelector } from '../reducers/app.js';
import { getEnvironment } from '../common/helpers.js';
import { Member } from '../reducers/member.js';
import Session from '../common/Session.js';
import * as Sentry from '/web_modules/@sentry/browser.js';
// import LogRocket from '/web_modules/logrocket.js';
import './widgets/app-drawer.js';
import './widgets/app-bar.js';
import './widgets/app-menu.js';
import './widgets/fch-snackbar.js';
import { updateStory, updateStoryProgress } from '../actions/story.js';

class FchAdmin extends connect(store)(LitElement) {

  @property({type: Boolean})
  isMobile: boolean = false;

  @property({type: String})
  page: string = '';

  @property({type: Object})
  member?: Member;

  @property({type: Object})
  snackbar?: Snackbar;

  public drawer: any;

  public mainEl: any;

  public scrollPosition = 0;

  static get styles() {
    return [
      FchSharedStyles,
      css`
        :host {
          display: block;
          --color-primary: #002e5a;
          --color-primary-dark: #001d3c;
          --color-primary-light: #9299a2;
          --color-secondary: #50ef88;
          --color-typography-primary: #2f3338;
          --color-typography-light: #84919e;
        }
        @media screen {
          .user-active {
            background-color: #fff;
            color: #999;
            border-top-left-radius: 3px;
            border-top-right-radius: 3px;
          }
          .drawer-frame-root {
            display: flex;
            height: 100vh;
          }
          app-drawer a .material-icons,
          app-drawer a iron-icon {
            color: #9eb3ca;
          }
          app-drawer a[slot="nav-main"] .material-icons,
          app-drawer a[slot="nav-main"] iron-icon {
            margin-right: 25px;
          }
          app-drawer a.active .material-icons,
          app-drawer a.active iron-icon {
            color: var(--color-secondary);
          }
          .app-content {
            position: relative;
            background-color: #fdfdfd;
            width: 100%;
            overflow-x: hidden;
          }
          app-bar {
            padding: 0 25px;
          }
          app-bar .title {
            font-size: 22px;
            /* margin-left: 15px; */
            -webkit-font-smoothing: antialiased;
          }
          app-bar app-menu button {
            color: #fff;
          }
          #user-menu {
            margin-left: 10px;
          }
          .main-content {
            overflow: auto;
            height: 100%;
          }
          .app-bar-fixed-adjust {
            margin-top: 56px;
          }
          main div > * {
            display: none;
            opacity: 0;
          }
          main div > .active {
            display: block;
            animation-name: fadein;
            animation-duration: 0.5s;
            animation-fill-mode: forwards;
          }
          @keyframes fadein {
            from {opacity: 0;}
            to  {opacity: 1;}
          }
          @media(max-width: 576px) {
            main {
              min-width: calc(100vw - 60px);
            }
          }
          app-drawer a .icon-trailing {
            flex-grow: 1;
            text-align: right;
          }
          app-drawer a .icon-trailing span {
            background: red;
            border-radius: 10px;
            padding: 0 7px;
            text-transform: lowercase;
            color: #fff;
          }
        }
        @media print {
          app-bar,
          app-drawer,
          fch-snackbar {
            display: none;
          }
        }
      `
    ];
  }

  render() {
    const page = this.page;

    const {
      warning = '',
      message = '',
      type = 'default'
    } = { ...this.snackbar };

    return html`
      ${!Session.valid
        ? html`
         <main>
          <fch-login
            class="${classMap({'active': page === 'login'})}"></fch-login>
          <password-reset
            class="${classMap({'active': page === 'password-reset'})}"></password-reset>
         </main>
        `
        : html`
          <div class="drawer-frame-root">
            <app-drawer class="drawer-open">
              <a href="/stories" slot="nav-main" class="${classMap({'active': page === 'stories'})}">
                <i class="material-icons">subject</i> Stories
              </a>

              <hr slot="nav-main">

              <a href="/events" slot="nav-main" class="${classMap({'active': page === 'events'})}">
                <i class="material-icons">event</i> Events
              </a>
              <a href="/event-registrations" slot="nav-main" class="${classMap({'active': page === 'event-registrations'})}">
                <i class="material-icons">person</i> Event registrations
              </a>

              <hr slot="nav-main">

              <a href="/themes" slot="nav-main" class="${classMap({'active': page === 'themes'})}">
                <i class="material-icons">border_outer</i> Themes
              </a>
              <a href="/country-profiles" slot="nav-main" class="${classMap({'active': page === 'country-profiles'})}">
                <i class="material-icons">person_pin_circle</i> Country profiles (beta)
              </a>
              <a href="/case-studies" slot="nav-main" class="${classMap({'active': page === 'case-studies'})}">
                <i class="material-icons">extension</i> Case studies (beta)
              </a>
              <a href="/regulator-focuses" slot="nav-main" class="${classMap({'active': page === 'regulator-focuses'})}">
                <i class="material-icons">extension</i> Regulator focus (beta)
              </a>

              <hr slot="nav-main">

              <a href="/reports" slot="nav-main" class="${classMap({'active': page === 'reports'})}">
                <i class="material-icons">dashboard</i> Reports
              </a>

              <a href="/advanced-search" slot="nav-main" class="${classMap({'active': page === 'advanced-search'})}">
                <i class="material-icons">search</i> Advanced Search
              </a>

              <a href="/saved" slot="nav-main" class="${classMap({'active': page === 'saved'})}">
                <i class="material-icons">folder</i> Folders
              </a>

              <a href="/channels" slot="nav-main" class="${classMap({'active': page === 'channels'})}">
                <i class="material-icons">rss_feed</i> Channels
              </a>

              <hr slot="nav-main">

              <a href="/categories" slot="nav-main" class="${classMap({'active': page === 'categories'})}">
                <i class="material-icons">format_list_numbered</i>
                <span class="text">Categories</span>
              </a>
              <a href="/typologies" slot="nav-main" class="${classMap({'active': page === 'typologies'})}">
                <i class="material-icons">pie_chart</i>
                <span class="text">Typologies</span>
              </a>
              <a href="/jurisdictions" slot="nav-main" class="${classMap({'active': page === 'jurisdictions'})}">
                <i class="material-icons">language</i>
                <span class="text">Jurisdictions</span>
              </a>
              <a href="/regulators" slot="nav-main" class="${classMap({'active': page === 'regulators'})}">
                <i class="material-icons">gavel</i>
                <span class="text">Regulators</span>
              </a>

              <hr slot="nav-main">

              <a href="/members" slot="nav-main" ?hidden="${!!this.member && this.member.Role.name !== 'admin'}" class="${classMap({'active': page === 'members'})}">
                <i class="material-icons">person</i>
                <span class="text">Members</span>
              </a>
              <a href="/profiles" slot="nav-main" class="${classMap({'active': page === 'profiles'})}">
                <i class="material-icons">account_circle</i>
                <span class="text">Author profiles</span>
              </a>
              <a href="/organisations" slot="nav-main" class="${classMap({'active': page === 'organisations'})}">
                <i class="material-icons">apartment</i>
                <span class="text">Organisations</span>
              </a>

              <hr slot="nav-main">

              <a href="/entities" slot="nav-main" class="${classMap({'active': page === 'entities'})}">
                <i class="material-icons">hive</i>
                <span class="text">Entities</span>
              </a>

              <a href="/dictionary" slot="nav-main" class="${classMap({'active': page === 'dictionary'})}">
                <i class="material-icons">chrome_reader_mode</i>
                <span class="text">Dictionary</span>
              </a>

              <hr slot="nav-main">

              <!-- TODO: remove any diffbot related feature (also from the backend and database)! -->
              <!-- a href="/diffbot-headlines" slot="nav-main" class="$ {classMap({'active': page === 'diffbot-headlines'})}">
                <i class="material-icons">notification_important</i>
                <span class="text">Diffbot headlines</span>
              </a-->
              <a href="/visitors" slot="nav-main" class="${classMap({'active': page === 'visitors'})}">
                <i class="material-icons">transfer_within_a_station</i>
                <span class="text">Visitors</span>
              </a>
              <a href="/gpt-playground" slot="nav-main" class="${classMap({'active': page === 'gpt-playground'})}">
                <i class="material-icons">extension</i>
                <span class="text">GPT3 playground</span>
              </a>
              <a href="/newsletters" slot="nav-main" class="${classMap({'active': page === 'newsletters'})}">
                <i class="material-icons">extension</i>
                <span class="text">Newsletters</span>
              </a>
              <a href="/sandbox" slot="nav-main" class="${classMap({'active': page === 'sandbox'})}" hidden>
                <i class="material-icons">extension</i>
                <span class="text">Sandbox</span>
              </a>
              <a href="/assistant-demo" slot="nav-main" class="${classMap({'active': page === 'assistant-demo'})}">
                <i class="material-icons">headset_mic</i>
                <span class="text">Assistant demo</span>
              </a>
            </app-drawer>

            <div class="app-content">
              <app-bar>
                <div slot="left">
                  <span class="title">${this.capitalize(page?.replace('-', ' ') || 'Dashboard')}</span>
                </div>
                <div slot="right">
                  <a href="https://fcdclientproduction.z6.web.core.windows.net" class="material-icons" target="_blank">remove_red_eye</a>
                  <div id="user-menu">
                    <app-menu left>
                      <button slot="button">${this.member?.full_name.split(' ')[0] || ''}</button>
                      <iron-icon slot="trailing-icon" icon="chevron-down"></iron-icon>

                      <li slot="item" class="disabled">${this.member?.email}</li>
                      <li slot="item" @click="${this.signOut}"><a href="">Sign out</a></li>
                    </app-menu>
                  </div>
                </div>
              </app-bar>

              <main class="main-content">
                <div class="app-bar-fixed-adjust">
                  <fch-admin-stories
                    class="${classMap({'active': page === 'stories'})}"></fch-admin-stories>
                  <admin-events
                    class="${classMap({'active': page === 'events'})}"></admin-events>
                  <admin-event
                    class="${classMap({'active': page === 'event'})}"></admin-event>
                  <fcd-event-registrations
                    class="${classMap({'active': page === 'event-registrations'})}"></fcd-event-registrations>
                  <fch-admin-story
                    class="${classMap({'active': page === 'story'})}"></fch-admin-story>
                  <admin-themes
                    class="${classMap({'active': page === 'themes'})}"></admin-themes>
                  <fcd-country-profiles
                    class="${classMap({'active': page === 'country-profiles'})}"></fcd-country-profiles>
                  <fcd-country-profile
                    class="${classMap({'active': page === 'country-profile'})}"></fcd-country-profile>
                  <fcd-case-studies
                    class="${classMap({'active': page === 'case-studies'})}"></fcd-case-studies>
                  <fcd-case-study
                    class="${classMap({'active': page === 'case-study'})}"></fcd-case-study>
                  <fcd-regulator-focuses
                    class="${classMap({'active': page === 'regulator-focuses'})}"></fcd-regulator-focuses>
                  <fcd-regulator-focus
                    class="${classMap({'active': page === 'regulator-focus'})}"></fcd-regulator-focus>
                  <admin-theme
                    class="${classMap({'active': page === 'theme'})}"></admin-theme>
                  <fcd-channels
                    class="${classMap({'active': page === 'channels'})}"></fcd-channels>
                  <fcd-channel
                    class="${classMap({'active': page === 'channel'})}"></fcd-channel>
                  <fcd-reports
                    class="${classMap({'active': page === 'reports'})}"></fcd-reports>
                  <advanced-search
                    class="${classMap({'active': page === 'advanced-search'})}"></advanced-search>
                  <saved-stories
                    class="${classMap({'active': page === 'saved'})}"></saved-stories>
                  <fcd-report-editor
                    class="${classMap({'active': page === 'report-editor'})}"></fcd-report-editor>
                  <fch-admin-category
                    class="${classMap({'active': page === 'categories'})}"></fch-admin-category>
                  <fch-admin-jurisdiction
                    class="${classMap({'active': page === 'jurisdictions'})}"></fch-admin-jurisdiction>
                  <fch-admin-typology
                    class="${classMap({'active': page === 'typologies'})}"></fch-admin-typology>
                  <admin-regulator
                    class="${classMap({'active': page === 'regulators'})}"></admin-regulator>
                  <fch-admin-member
                    class="${classMap({'active': page === 'members'})}"></fch-admin-member>
                  <fcd-author-profiles
                    class="${classMap({'active': page === 'profiles'})}"></fcd-author-profiles>
                  <fcd-dictionary
                    class="${classMap({'active': page === 'dictionary'})}"></fcd-dictionary>
                  <fcd-entities
                    class="${classMap({'active': page === 'entities'})}"></fcd-entities>
                  <fcd-organisations
                    class="${classMap({'active': page === 'organisations'})}"></fcd-organisations>
                  <fcd-organisation
                    class="${classMap({'active': page === 'organisation'})}"></fcd-organisation>
                  <fcd-diffbot-main
                    class="${classMap({'active': page === 'diffbot-headlines'})}"></fcd-diffbot-main>
                  <fcd-visitors
                    class="${classMap({'active': page === 'visitors'})}"></fcd-visitors>
                  <gpt-playground
                    class="${classMap({'active': page === 'gpt-playground'})}"></gpt-playground>
                  <fcd-sandbox
                    class="${classMap({'active': page === 'sandbox'})}"></fcd-sandbox>
                  <fcd-assistant-demo
                    class="${classMap({'active': page === 'assistant-demo'})}"></fcd-assistant-demo>
                  <fcd-newsletters
                    class="${classMap({'active': page === 'newsletters'})}"></fcd-newsletters>
                  <fcd-newsletter-composer
                    class="${classMap({'active': page === 'newsletter-composer'})}"></fcd-newsletter-composer>
                  <fch-404-warning
                    class="${classMap({'active': page === '404'})}"></fch-404-warning>
                </div>
              </main>
            </div>

            <fch-snackbar
              class="${classMap({'warning': warning, [type]: true, 'opened': message})}">
              ${message}
            </fch-snackbar>
        </div>
        `
      }
    `;
  }

  firstUpdated() {
    this.isMobile = document.documentElement.clientWidth <= 587;
    if (!this.shadowRoot) return;

    this.drawer = this.shadowRoot.querySelector('app-drawer');
    this.mainEl = this.shadowRoot.querySelector('.main-content');

    ///Get the user session if there's one in localStorage
    const session = Session.get();
    const version = store.getState().app.version;
    const {env, apiUrl} = getEnvironment();

    if (env !== 'development') {
      Sentry.init({
        environment: env,
        release: `financial-crime-digest@${version}`,
        dsn: 'https://12d3fe2c2c904c2cb178acb7555ccd85@o219383.ingest.sentry.io/4504054008119296',
        integrations: [
          new Sentry.BrowserTracing(),
          new Sentry.Replay({
            maskAllText: false,
            blockAllMedia: false,
          })
        ],
        // Capture Replay for 10% of all sessions,
        // plus for 100% of sessions with an error
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
        beforeSend(event, _hint) {
          if (event.exception) {
            Sentry.showReportDialog({ eventId: event.event_id, user: {
              name: session?.member?.full_name,
              email: session?.member?.email
            } });
          }
          return event;
        }
      });

      // if (env !== 'development') {
      //   LogRocket.init('9b3scc/fcd');
      // }

      // if (session && session.member) {
      //   LogRocket.identify(String(session.member.id), {
      //     name: session.member.full_name,
      //     email: session.member.email
      //   });
      // }
    }

    store.dispatch(addSessionToRedux(session)).then(() => {
      installRouter(this._updateLocation.bind(this));
    });

    this.openWebSocket(apiUrl);

    window.addEventListener('popstate', () => {
      // FIXME: using the timer here is a hack
      // we need to figure it out why the scroll
      // position is not being set immediately.
      setTimeout(() => {
        this.mainEl?.scrollTo(0, this.scrollPosition);
        this.scrollPosition = 0;
      }, 10);
    });
  }

  stateChanged(state: RootState) {
    this.page = state.app.route[0];
    this.member = loggedInMemberSelector(state);

    //temp
    if (this.page === 'report-editor') {
      this.drawer?.close();
    }

    this.snackbar = state.app.snackbar;
  }

  async _updateLocation(location: Location) {
    if (this.scrollPosition === 0) {
      this.scrollPosition = this.mainEl?.scrollTop;
    }
    
    await store.dispatch(updateLocation(location));

    // FIXME: this is part of the hack at line #443
    this.mainEl?.scrollTo(0, 0);
  }

  getLocalSession() {
    const session = localStorage.getItem('fch-session');
    try {
      return JSON.parse(`${session}`) || {};
    } catch (e) {
      return {};
    }
  }

  signOut() {
    Session.delete();
    window.location.href = '/';
  }

  capitalize(str: string) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  openWebSocket(apiUrl: string) {
    const socket = new WebSocket(apiUrl.replace(/(http)(s)?/, 'ws$2'));
    socket.onopen = () => console.log('Websocket opened!');
    socket.onerror = (e) => console.error(e);

    socket.onmessage = (e) => {
      const {event, data} = JSON.parse(e.data);
      console.log({event, data});

      if (event === 'story-progress') {
        store.dispatch(updateStoryProgress(data.progresses));
      }

      if (event === 'story-processed' || event === 'processing-story-failed') {
        store.dispatch(updateStory(data.story));
      }
    };
  }
}
window.customElements.define('fch-admin', FchAdmin);
